// File: frontend/src/content/publicPricing.js
//
// What PesaFii charges, as published on the landing page.
//
// These are NOT the rates the platform charges with. Charging happens in
// backend/services/fees.js, whose newest scheduled FEE_POLICIES entry
// (v2_6p_2g_2v, effective 2026-08-03 13:10 EAT) sets platform 6%, gateway 2%
// and voucher activation 2%. The Terms of Service ("Fees, pricing and how we
// are paid", content/termsOfService.js) publish the same numbers.
//
// A local test (publicPricing.test.js) reads all three and fails if they stop
// agreeing. When a new fee policy is scheduled, change this file, the Terms and
// the policy together, and never before the policy takes effect.

export const PRICING = Object.freeze({
  subscription: "No monthly subscription",
  platformFeePct: 6,
  gatewayFeePct: 2,
  voucherActivationPct: 2,
  termsHref: "/terms#fees",
});

export const COLLECTION_FEE_TOTAL_PCT = PRICING.platformFeePct + PRICING.gatewayFeePct;
